import React, { Component } from 'react'
import ColIndicator from '../common/ColIndicator'
import './main-col-cp.css'

class MainColCP extends Component {
  constructor() {
    super();
    // this.state = {}
  }

  render() {
    let titleText = ''
    if (this.props.title) {
      titleText = `-${this.props.title}-`
    }
    return (
      <div className={'main-col ' + (this.props.className||'')}>
        <div className='main-col-header'>
          {titleText}
          <ColIndicator />
        </div>
        <div className='main-col-content'>{this.props.children}</div>
      </div>
    )
  }
}

export default MainColCP
